import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'

import { approvalFeedbacksService } from 'src/services/approval-feedbacks.service'

export const useGetApprovalFeedbacksByIds = (ids: string[]) => {
  return useQuery(
    [QUERY_KEYS.APPROVAL_FEEDBACKS_BY_IDS, ids],
    () => approvalFeedbacksService.getApprovalFeedbacksByIds(ids),
    {
      keepPreviousData: true,
      enabled: ids && ids.length > 0,
    },
  )
}
